import { CoreAPI, createCommonProfileMethods } from '@hero/sdk-core';

/** Carrier-facing `Profile` APIs. Read-only — writes are super-admin. */
export function createProfilesAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonProfileMethods(coreAPI),
  };
}
